<template>
  <div class="ty-main">
    <div class="ty-tip">
      <div class="ty-img">
        <img src="../../assets/images/prompt.png" />
      </div>

      <div class="tip">
        配置系统中企业的基础信息
      </div>
    </div>
    <div class="ty-content white">
      <el-row class="set">
        <el-col :span="24">
          <el-form ref="companyForm" :model="companyForm" :rules="rules" label-width="160px" @submit.native.prevent>
          <h3>服务到期</h3>
            <el-form-item label="服务时间：">
              <el-input :disabled="disabled01" v-model="companyForm.corptime"></el-input>
            </el-form-item>
          <h3>信息配置</h3>
            <el-form-item label="企业名称：" prop="corpname" style="margin-bottom: 24px;">
              <el-input :disabled="disabled"  maxlength="8" show-word-limit clearable v-model.trim="companyForm.corpname"></el-input>
            </el-form-item>
            <el-form-item label="企业logo：" prop="logo" >
              <el-input clearable v-model="companyForm.logo" v-show="false"></el-input>
              <div style="display: flex;align-items: flex-end;">
                <!-- :action="apiapiUrl + '//api/upload'" -->
                <el-upload
                  class="avatar-uploader"
                  :disabled="disabled"
                  :action="apiUrl + '/api/system/upload/logo'"
                  :show-file-list="false"
                  :on-success="uploadSuccess"
                  :on-error="imgUploadError"
                  :before-upload="beforeUpload"
                  :data="{ type: 'image' }"
                  :headers="uploadHeaders"
                  accept=".jpg,.jpep,.png,.bmp"
                >
                  <img v-if="companyForm.logo !== ''" :src="companyForm.logo" class="avatar" />
                  <img v-else src="../../assets/images/tupian.png" class="avatar" />
                </el-upload>
               <p class="fsdf">请上传1:1企业logo，尺寸大于40px * 40px；</p>
              </div>
            </el-form-item>
            <h3>加密配置</h3>
              <el-form-item label="代码加密：">
                <el-input :disabled="disabled01" v-model="companyForm.code_encryption"></el-input>
              </el-form-item>
              <el-form-item label="数据库敏感信息加密：" style="margin-top: 16px;">
                <el-input :disabled="disabled01" v-model="companyForm.database_encryption"></el-input>
              </el-form-item>
              <el-form-item label="数据盘加密：" style="margin-top: 16px;">
                <el-input :disabled="disabled01" v-model="companyForm.data_disk_encryption"></el-input>
              </el-form-item>
            <h3>功能配置</h3>
              <el-form-item label="功能模块：">
                <el-checkbox-group v-model="checkList">
                  <el-checkbox
                  v-for="(item, index) in authList"
                  :key="index"
                  :label="item.value"
                  @change="getCode(item)"
                  :disabled="disabled01">{{item.label}}</el-checkbox>
                  </el-checkbox-group>
              </el-form-item>
            <div class="footer">
                <el-button type="info" plain v-if="disabled === false" @click="close">取消</el-button>
                <el-button class="dsfdi" type="primary" v-if="disabled === false" @click="submitForm('companyForm')">保存</el-button>
                <el-button class="dsfdi" type="primary" v-else @click="submit">编辑</el-button>
              </div>
          </el-form>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
// import { apiUrlz, apiUrl } from '@/config/constant'
import { apiUrl } from '@/config/constant'
const uploadHeaders = {
  // verifyAccessToken: sessionStorage.getItem('token'),
  // UserToken: sessionStorage.getItem('userToken')
  verifyAccessToken: sessionStorage.getItem('token'),
  verifyUserId: sessionStorage.getItem('userId')
}
export default {
  data() {
    return {
      disabled: true,
      disabled01: true,
      uploadHeaders,
      // apiapiUrl: apiUrlz,
      apiUrl: apiUrl,
      companyForm: {
        corptime: '',
        corpname: '',
        logo: '',
        radio1: '',
        radio2: '',
        radio3: ''
      },
      form: {
        corptime: ''
      },
      rules: {
        logo: [{ required: true, message: 'logo不能为空', trigger: 'blur' }],
        corpname: [{ required: true, message: '企业名称企业名称不能为空', trigger: 'blur' }]
      },
      checkList: [],
      authList: [
        {
          label: '服务质量',
          value: '0'
        },
        {
          label: '风险预警',
          value: '1'
        },
        {
          label: '内容审计',
          value: '2'
        },
        {
          label: '敏感词设置',
          value: '3'
        },
        {
          label: '敏感操作',
          value: '4'
        },
        {
          label: '离职继承',
          value: '5'
        },
        {
          label: '会话共享',
          value: '6'
        },
        {
          label: '系统管理',
          value: '7'
        }],
        time: ''
    }
  },
  mounted() {
    this.getDetail()
  },
  methods: {
    getDetail() {
      this.$api.get('/api/system/setting/corp/index').then(res => {
        if (res) {
          this.companyForm.corpname = res.name
          this.companyForm.logo = res.logo
          this.checkList = JSON.parse(res.menu_label)
          this.companyForm.corptime = res.service_start_time + ' - ' + res.service_end_time
          this.companyForm.code_encryption = res.code_encryption
          this.companyForm.data_disk_encryption = res.data_disk_encryption
          this.companyForm.database_encryption = res.database_encryption
          if (this.companyForm.code_encryption === '1') {
            this.companyForm.code_encryption = '是'
          } else if (this.companyForm.code_encryption === '2') {
            this.companyForm.code_encryption = '否'
          } else {
            this.companyForm.code_encryption = '-'
          }
          if (this.companyForm.data_disk_encryption === '1') {
            this.companyForm.data_disk_encryption = '是'
          } else if (this.companyForm.data_disk_encryption === '2') {
            this.companyForm.data_disk_encryption = '否'
          } else {
            this.companyForm.data_disk_encryption = '-'
          }
          if (this.companyForm.database_encryption === '1') {
            this.companyForm.database_encryption = '是'
          } else if (this.companyForm.database_encryption === '2') {
            this.companyForm.database_encryption = '否'
          } else {
            this.companyForm.database_encryption = '-'
          }
          this.time = res.updated_at
          this.$store.commit('updatelog2')
        }
      })
    },
    getPei() {
      const parse = {
        corpid: this.corpid
      }
      this.$api.post('/api/corp/get/menu/label', parse).then(res => {
        res.forEach(k => {
          this.authList.forEach(p => {
            if (k.menu_label === p.value) {
              this.checkList.push(k.menu_label)
            }
          })
        })
        const newArr = []
        for (let i = 0; i < this.checkList.length; i++) {
          if (newArr.indexOf(this.checkList[i]) === -1) {
            newArr.push(this.checkList[i])
          }
        }
        this.list = newArr
      })
    },
    submit() {
      this.disabled = false
    },
    close() {
      this.disabled = true
      this.$router.go(0)
    },
    submitForm(companyForm) {
      this.$refs[companyForm].validate((valid) => {
        if (valid) {
          this.$confirm('确定保存企业信息配置吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          showClose: false,
          closeOnClickModal: false
        })
          .then(() => {
            this.$api
              .post('/api/system/setting/corp/data', {
                  name: this.companyForm.corpname,
                  logo: this.companyForm.logo,
                  lastUpdateTime: this.time
              })
              .then(() => {
                this.$store.commit('updatelog')
                this.$message.success('修改成功')
                this.disabled = true
              })
              .catch(() => {
                // this.$message.error('修改失败')
                this.disabled = true
              })
            })
        } else {
          return false
        }
      })
    },
    // LOGO上传
    uploadSuccess(res, file) {
      if (res.ret === 200) {
        // this.companyForm.logo = this.apiUrl + res.data
        this.companyForm.logo = res.data
        this.$message.success('LOGO上传成功！')
      } else {
        this.$message.success('LOGO上传失败！')
      }
    },
    imgUploadError() {
      this.$message.success('LOGO上传失败！')
    },
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      return isLt2M
    }
  }
}
</script>

<style lang="scss" scoped>
.ty-main .ty-content.white{
  padding: 30px 24px;
  color: #000000;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #4d6eb1;
}

.avatar-uploader-icon {
  font-size: 36px;
  color: #8c939d;
  width: 78px;
  height: 78px;
  line-height: 78px;
  text-align: center;
  background: rgba(216, 220, 230, 0.12);
  border-radius: 2px;
}
.avatar {
  width: 78px;
  height: 78px;
  display: block;
}
::v-deep .el-form-item{
  margin-bottom:0;
  // height: 62px;
}
.title {
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-size: 17px;
  color: rgba(48, 49, 51, 0.9);
  margin-top: 32px;
  font-weight: bold;
  letter-spacing: 1px;
}
::v-deep .el-form {
  width: 90%;
}
::v-deep .el-form-item__label{
  font-size: 14px;
  line-height: 40px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #303133;
}
p{
  position: relative;
  top: -10px;
  left: 16px;
  font-size: 12px;
  color: rgba(0,0,0,0.3000);
  margin-top: -30px;
}
.tu {
  z-index:999;
}
.fing{
    position: absolute;
    top: 32px;
    left: 8px;
    width: 14px;
    height: 14px;
}
::v-deep .el-input.is-disabled .el-input__inner{
  font-size: 14px;
  background: #F5F7FA;
  border: 1px solid #D8DCE6;
}
.ding{
  position: absolute;
  top: 800px;
  left: 128px;
  width: 14px;
  height: 14px;
}
.ding01{
  position: absolute;
  top: 624px;
  left: 147px;
  width: 14px;
  height: 14px;
}
::v-deep .el-checkbox{
  width: 25%;
  margin-right: 0;
}
::v-deep .el-checkbox-group{
  background: #F5F7FA;
  padding:28px 10.4%;
  border: 1px solid #D8DCE6;
}
::v-deep .el-form-item__content {
  line-height: 40px;
}
.footer{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 40px;
}
h3{
  font-size: 16px;
  font-weight: 550;
  color: #041D34;
  padding-bottom: 12px;
  border-bottom: 1px solid #E4E7ED;
}
.fsdf{
  font-weight: 400;
  color: rgba(0,0,0,0.3);
  font-size: 12px;
}
</style>
